// extracted by mini-css-extract-plugin
module.exports = {"warningModalHeader":"WarningModalHeader_warningModalHeader__zDAgc"};